export default "__VITE_ASSET__d5428259__"